import BpkProgress from '@skyscanner-internal/backpack-web/bpk-component-progress';
import BpkRating, {
  RATING_SIZES,
  RATING_SCALES,
} from '@skyscanner-internal/backpack-web/bpk-component-rating';
import BpkThemeProvider from '@skyscanner-internal/backpack-web/bpk-theming';

import { marcommsDarkSky } from '@skyscanner/bpk-foundations-web/tokens/base.es6';

import STYLES from './index.module.scss';

const MAX_VALUE = 5;
const MIN_VALUE = 0;

export default ({
  ariaLabel,
  label,
  rating,
}: {
  rating: number;
  label: string;
  ariaLabel: string;
}) => (
  <div className={STYLES.Rating} aria-label={ariaLabel} role="status">
    <div className={STYLES.Rating__description}>
      <div className={STYLES.Rating__label}>{label}</div>
      {rating > 1 && (
        <div className={STYLES.Rating__rating}>
          <BpkRating
            ariaLabel=""
            title=""
            size={RATING_SIZES.base}
            ratingScale={RATING_SCALES.zeroToFive}
            value={rating}
          />
        </div>
      )}
    </div>
    <div className={STYLES.Rating__progress}>
      <BpkThemeProvider
        theme={{ progressBarFillColor: marcommsDarkSky }}
        themeAttributes={['progressBarFillColor']}
      >
        <BpkProgress
          className={STYLES.Rating__progress__theme}
          min={MIN_VALUE}
          max={MAX_VALUE}
          small
          value={rating}
          aria-label={label}
          role="progressbar"
        />
      </BpkThemeProvider>
    </div>
  </div>
);
